import useDestinationAccount from "./useDestinationAccount";
import {
  STEP_DESTINATION_ACCOUNT,
  STEP_DESTINATION_CHOICES,
  STEP_DESTINATION_CONNECT_ES,
  STEP_DESTINATION_CONNECT_ES_DETAILS,
  STEP_DESTINATION_CONNECT_ES_UPLOAD_STATEMENT,
  STEP_DESTINATION_CONNECT_IRA,
  STEP_DESTINATION_CONNECT_IRA_TYPE,
  STEP_DESTINATION_FLASH_LOADING,
  STEP_DESTINATION_OPEN_AND_CONNECT_IRA,
  STEP_DESTINATION_OPTIONS,
  STEP_DESTINATION_OPTIONS_TYPE,
} from "../../class/transferDetails";
import MainScreen from "./screens/MainScreen";
import LoadingScreen from "../general/loading-screen";
import DestinationOptions from "./screens/DestinationOptions";
import DestinationOptionType from "./screens/DestinationOptionType";

import ConnectIRA from "./screens/ConnectIRA";
import PlanSponsorName from "./screens/PlanSponsorName";
import UploadStatement from "./screens/UploadStatement";
import ESDetails from "./screens/ESDetails";
import ConnectIRAType from "./screens/ConnectIRAType";
import FlashLoadingScreen from "./screens/FlashLoadingScreen";
import OpenAndConnectIRA from "./screens/OpenAndConnectIRA";
import DestinationChoiceScreen from "./screens/DestinationChoiceScreen";

const DestinationAccountScreen = () => {
  const props = useDestinationAccount();
  const { isLoading, currentDestinationStep } = props;

  if (isLoading && currentDestinationStep !== STEP_DESTINATION_FLASH_LOADING) {
    return <LoadingScreen loadingScreenMessage="Loading your destination options" />;
  }

  switch (currentDestinationStep) {
    case STEP_DESTINATION_ACCOUNT:
      return <MainScreen {...props} />;
    case STEP_DESTINATION_OPTIONS:
      return <DestinationOptions {...props} />;
    case STEP_DESTINATION_OPTIONS_TYPE:
      return <DestinationOptionType {...props} />;
    case STEP_DESTINATION_CONNECT_ES:
      return <PlanSponsorName {...props} />;
    case STEP_DESTINATION_CONNECT_ES_UPLOAD_STATEMENT:
      return <UploadStatement {...props} />;
    case STEP_DESTINATION_CONNECT_ES_DETAILS:
      return <ESDetails {...props} />;
    case STEP_DESTINATION_CONNECT_IRA:
      return <ConnectIRA {...props} />;
    case STEP_DESTINATION_CONNECT_IRA_TYPE:
      return <ConnectIRAType {...props} />;
    case STEP_DESTINATION_OPEN_AND_CONNECT_IRA:
      return <OpenAndConnectIRA {...props} />;
    case STEP_DESTINATION_FLASH_LOADING:
      // For transfer in fixed destination && transfer in optional destination
      return <FlashLoadingScreen {...props} />;
    case STEP_DESTINATION_CHOICES:
      return <DestinationChoiceScreen {...props} />;
    default:
      return <MainScreen {...props} />;
  }
};

export default DestinationAccountScreen;
